<template>
  <span>
    <button class="chbtn bk" @click="bkDialog = true">
      <img src="~assets/img/onlineblock/soundfilled003.png" style="transform:translateY(1px)" />
      拉黑
    </button>
    <Modal v-model="bkDialog" width="360" footer-hide :styles="{top: '20%'}" class="error-modal">
      <div style="text-align:center">
        <img src="~assets/img/onlineblock/attentionmulticolor.png" alt />
        <p>确定要拉黑 {{cu.nickname}}吗 ？</p>
        <div class="btngroup">
          <Button class="btn" type="default" @click="bkDialog = false">取消</Button>
          <Button class="btn" type="error" @click="comfirnBklistSubmit">确认</Button>
        </div>
      </div>
    </Modal>

    <Modal v-model="addBkStatus" width="360" footer-hide :styles="{top: '20%'}" class="error-modal">
      <div style="text-align:center">
        <img v-if="addsure" src="~assets/img/onlineblock/successmulticolor.png" alt />
        <img v-else src="~assets/img/onlineblock/attentionmulticolor.png" alt />
        <p>{{bkResultContent}}</p>
        <div class="btngroup">
          <Button class="btn" type="default" @click="addBkStatus = false">关闭</Button>
        </div>
      </div>
    </Modal>
  </span>
</template>
<script>
import { mapGetters } from "vuex"

export default {
  name: "ModalBlackUser",
  props: {
    cu: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      bkResultContent: "",
      addBkStatus: false,
      addsure: false,
      bkDialog: false,
    }
  },
  computed: {
    ...mapGetters(["username"]),
  },
  methods: {
    comfirnBklistSubmit () {
      let obj = {
        cuid: this.cu.cuid,
        maid: this.username.maid,
        actionstate: 1
      };
      this.$axios
        .updbklist(obj)
        .then(res => {
          this.bkDialog = false;
          this.addBkStatus = true
          if (res.status === 1) {
            this.addsure = true
            this.bkResultContent = `已将 ${this.cu.nickname} 加入黑名单`
          } else {
            this.addsure = false
            this.bkResultContent = res.msg
          }
          this.$emit("getBlackList",this.cu.cuid)
        })
        .catch(err => console.error(err));
    }
  }
}
</script>
<style lang="less">
  .bk {
    background-color: var(--main-black);
  }
</style>